module.exports = "<sb-card-list source=\"vm.source\" config=\"vm.config\" actions=\"vm.actions\" transform=\"vm.transform\" empty-state=\"vm.emptyState\"></sb-card-list>";


//////////////////
// WEBPACK FOOTER
// ./src/sharebase-app/components/tasks-cards/tasks-cards.template.html
// module id = 1273
// module chunks = 0